(function () {
  var settings = {
    delay: 6000
  }
  var script_loaded = false;
  
  function loadAsync() {
    if (script_loaded) {
      return
    } else {
      script_loaded = true;
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute("data-src") !== null) {
          scripts[i].setAttribute('src', scripts[i].getAttribute("data-src"));
          delete scripts[i]['dataset']['src']
        }
        if (scripts[i].getAttribute('type') === 'text/javascripts') {
          var newScript = document.createElement('script');
          for (var j = 0; j < scripts[i].attributes.length; j++) {
            var atribute = scripts[i].attributes[j];
            newScript.setAttribute(atribute.name, atribute.value)
          }
          newScript.type = "text/javascript";
          newScript.innerHTML = scripts[i].innerHTML;
          scripts[i].parentNode.removeChild(scripts[i]);
          scripts[i].parentNode.insertBefore(newScript, scripts[i])
        }
      }
      var linkTags = document.getElementsByTagName('link');
      for (i = 0; i < linkTags.length; i++) {
        if (linkTags[i].getAttribute('data-href') !== null) {
          linkTags[i].setAttribute('href', linkTags[i].getAttribute('data-href'));
          delete linkTags[i].dataset.href
        }
      }
      document.dispatchEvent(new CustomEvent("StartKernelLoading"));
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading"))
      }, 1200)
    }
  }
  window.addEventListener("scroll", function() {
    loadAsync()
  });
  window.addEventListener("mousemove", function() {
    loadAsync()
  });
  window.addEventListener("touchstart", function() {
    loadAsync()
  });
  if (window.addEventListener) {
    window.addEventListener("load", function() {
      setTimeout(loadAsync, settings.delay)
    }, false)
  } else {
    if (window.attachEvent) {
      window.attachEvent("onload", function() {
        setTimeout(loadAsync, settings.delay)
      })
    } else {
      window.onload = loadAsync
    }
  }
})();